<template>
  <div id="app">
            <router-view style="font-size:12px;">
               
            </router-view>
                  <!-- <keep-alive>
                   <router-view v-if="$route.meta.keepAlive" style="font-size:12px;"></router-view>
                </keep-alive>
                 <router-view v-if="!$route.meta.keepAlive" style="font-size:12px;"></router-view> -->
    </div>
</template>

<script>
export default {
  data(){
    return {
        
    }
  },
  methods:{
        saveState () {
      sessionStorage.setItem('state', JSON.stringify(this.$store.state))
    }
  },
  mounted(){
     window.addEventListener('unload', this.saveState);
    window.addEventListener('offline',()=>{
        //网络由正常到异常时触发
        sessionStorage.locationUrl=window.location.href;
        this.$router.replace('/networkerror')
    });
      window.addEventListener('online',()=>{
        window.location.href=sessionStorage.locationUrl;
      });
  },
  created(){
     
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/App.vue